import { Component, Input, OnInit } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { TableMetaData } from '../../_models/components/table-meta-data.model';
import { LazyLoadEvent } from 'primeng/api';

@Component({
  selector: 'share-data-table',
  templateUrl: './share-data-table.component.html',
  styleUrls: ['./share-data-table.component.scss']
})
export class ShareDataTableComponent implements OnInit {
  @Input() dataSource: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);
  @Input() dataCount: number = 0;
  @Input() columns: any[] = [];

  private _metaData: TableMetaData = {
    totalRecords: 0,
    rows: 100,
    first: 0,
    loading: true,
    globalFilter: '',
    sort: '',
    id: ''
  };
  totalRecords: number = 0;

  // export interface TableMetaData {
  //   totalRecords: number;
  //   rows: number;
  //   first: number;
  //   loading?: boolean;
  //   sort?: string;
  //   globalFilter?: string;
  //   filter?: string[];
  //   id?: string;
  // }

  set metaData(value: TableMetaData) {
    this._metaData = value;
    this.totalRecords = value.totalRecords;
    // Don't emit here to avoid infinite loop
  }

  @Input() get metaData(): TableMetaData {
    return this._metaData;
  }

  constructor() {}

  ngOnInit(): void {
    this.metaData.totalRecords = this.dataCount;
  }

  loadDataLazy($event: LazyLoadEvent) {
    console.log($event);
    // window.alert('loadDataLazy');
  }
}
